import { render, staticRenderFns } from "./open-on-hover-menu.vue?vue&type=template&id=631b85fc&scoped=true&"
import script from "./open-on-hover-menu.vue?vue&type=script&lang=js&"
export * from "./open-on-hover-menu.vue?vue&type=script&lang=js&"
import style0 from "./open-on-hover-menu.vue?vue&type=style&index=0&id=631b85fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631b85fc",
  null
  
)

export default component.exports